$(function() {
  $('.grid-product__title').each(function() {
      var word = $(this).html();
      var index = word.indexOf(' ');
      if(index == -1) {
          index = word.length;
      }
    $(this).html('<span class="block-word">' + word.substring(0, index) +  '<sup> &#153; </sup></span>'  + word.substring(index, word.length));
  });
  $('#btnShowpartners').click(function(){
    var obj = $(this);
    var objTarg = $('#partnersWrap');
    var origHeight = 64 + $('ul',objTarg).outerHeight();
    var newHeight = 124 + $('ul',objTarg).outerHeight() * $('ul',objTarg).size();
    if (objTarg.hasClass('extended')){
      objTarg.animate({height: origHeight}).removeClass('extended');
    } else {
      objTarg.animate({height: newHeight}).addClass('extended');
    }
  });
  var $window = $(window),
      flexslider = { vars:{} },
      flexslider2 = { vars:{} };
  function getGridSize() {
    return (window.innerWidth < 600) ? 1 :
           (window.innerWidth < 900) ? 3 : 3;
  }
  function homeproductgetGridSize() {
    return (window.innerWidth < 600) ? 2 :
           (window.innerWidth < 900) ? 4 : 4;
  }
  function productgetGridSize() {
    return (window.innerWidth < 600) ? 2 :
           (window.innerWidth < 900) ? 5 : 5;
  }
  $window.resize(function() {
    var gridSize = getGridSize();
    flexslider.vars.minItems = gridSize;
    flexslider.vars.maxItems = gridSize;
  });
  if ($(window).width() <= 600){
    $(document).ready(function(){
      $('.featured-sale .flexslider').flexslider({
        animation: "slide",
        animationLoop: true,
        itemWidth: 238,
        itemMargin: 23,
        minItems: getGridSize(),
        maxItems: getGridSize()
      });
    });
  } else {
    $(document).ready(function(){
      $('.featured-sale .flexslider').flexslider({
        animation: "slide",
        animationLoop: true,
        itemWidth: 238,
        itemMargin: 23,
        customDirectionNav: $(".slider-btn a"),
        minItems: getGridSize(),
        maxItems: getGridSize()
      });
    });
  };
    
  $window.ready(function() {
    /*$('#challenge.flexslider').flexslider({
      animation: "slide",
      slideshow: true,
      slideshowSpeed: 5000,
      animationLoop: true,
      directionNav: false,
      controlNav: true,
      touch: false
    });*/
    $('#other-flex.flexslider').flexslider({
      animation: "slide",
      animationLoop: false,
      directionNav: true,
      controlNav: false,
      itemWidth: 210,
      itemMargin: 5,
      touch: true,
      minItems: productgetGridSize(), // use function to pull in initial value
      maxItems: productgetGridSize(),
      start: function(slider){
        flexslider2 = slider;
      }
    });
    $('.selection-list.flexslider').flexslider({
      animation: "slide",
      animationLoop: false,
      directionNav: true,
      controlNav: false,
      itemWidth: 190,
      itemMargin: 20,
      touch: true,
      minItems: getGridSize(), // use function to pull in initial value
      maxItems: getGridSize(),
      start: function(slider){
        flexslider = slider;
        $('.selections-home .slides li').show(); 
      }
    });
    $('.all-selection-list.flexslider').flexslider({
      animation: "slide",
      animationLoop: false,
      directionNav: true,
      controlNav: false,
      itemWidth: 250,
      itemMargin: 0,
      touch: true,
      minItems: getGridSize(), // use function to pull in initial value
      maxItems: getGridSize(),
      start: function(slider){
        flexslider = slider;
        $('.all-selection-list .slides li').show(); 
      }
    });
  });
  $window.resize(function() {
    var productgridSize = productgetGridSize();
    flexslider2.vars.minItems = productgridSize;
    flexslider2.vars.maxItems = productgridSize;
  });
  
  $('.remarkety-form').submit(function() {
    $('p.error, p.success').remove();
    if ($(this).find('input[type="email"]').val() !== '') {
        var data = $(this).serialize();
        $.ajax({
            type: "POST",
            url: "https://app.remarkety.com/public/subscribers/createcontact/",
            data: data,
            success: function() {
                $('#successMessage').show();
            },
            error: function() {
                $('#errorMessage').hide();
            }
        });
    } else {
    $(this).append(' <p class = "error" > Please fill in your email address. < /p> ');  
    }
     return false;
  });
  $('.signup_form').submit(function() {
    $('p.error, p.success').remove();
    
      var val = $('.inpt-signup').val();
      if (val == "kristine@wideumbrella.com") {
        $('#email_errorMessage').show();
      } else if (val == "edi@widerumbrella.com") {
        $('#email_errorMessage').show();
      } else if (val == "chuchay@wideumbrella.com") {
        $('#email_errorMessage').show();	
      } else if (val == "kyoootie888@yahoo.com") {
        $('#email_errorMessage').show();
      } else if (val == "werybrrats@yahoo.com") {
        $('#email_errorMessage').show();
      } else if (val == "kristine@nutrtion53.com") {
        $('#email_errorMessage').show();
      } else if (val == "londa0609@yahoo.com") {
        $('#email_errorMessage').show();
      } else if (val == "chrissyo1@nutrition53.com") {
        $('#email_errorMessage').show();
      } else if (val == "chrissyo@nutrition53.com") {
        $('#email_errorMessage').show();
      } else if (val == "cmcnutt1628@gmail.com") {
        $('#email_errorMessage').show();
      } else if (val == "cmcnutt2260@gmail.com") {
        $('#email_errorMessage').show();
      } else if (val == "k_manlapaz@yahoo.com") {
        $('#email_errorMessage').show();
      } else if (val == "anzee10@gmail.com") {
        $('#email_errorMessage').show();
      } else if (val == "pipkin@wideumbrella.com") {
        $('#email_errorMessage').show();
      } else if (val == "info@wideumbrella.com") {
        $('#email_errorMessage').show();
      } else if (val == "billr@nutrition53.com") {
        $('#email_errorMessage').show();
      } else if (val == "flo.aguilar099@gmail.com") {
        $('#email_errorMessage').show(); 
      } else if (val == "chrissyoliveira2020@gmail.com") {
        $('#email_errorMessage').show();
        
      //} else if (val == "") { 
        //$('#email_errorMessage').show();
      
      } else {
          var data = $(this).serialize();
          $.ajax({
              type: "POST",
              url: "https://app.remarkety.com/public/subscribers/createcontact/",
              data: data,
              success: function() {
                  $('#signup_successMessage').show();
                  $('.signup-header, .btn-submit, #email_errorMessage').hide();
              },
              error: function() {
                  $('#signup_errorMessage, #email_errorMessage').hide();
              }
          });
      } 
      return false;
  });
    
  $(".all-product-btn").click(function(event){
	 jQuery(".all-list").slideToggle(300);
     event.stopPropagation();
  });
  $(".btnWholesale").click(function(event){
	 jQuery(".withtoggle div").slideToggle(300);
     event.stopPropagation();
  });
  /*$('ul.tabs').each(function(){
    var $active, $content, $links = $(this).find('a');
    $active = $($links.filter('[href="'+location.hash+'"]')[0] || $links[0]);
    $active.addClass('active');
    $content = $($active[0].hash);
    $links.not($active).each(function () {
      $(this.hash).hide();
    });
    $(this).on('click', 'a', function(e){
      $active.removeClass('active').parent().removeClass('parent-active');
      $content.hide();
      $active = $(this);
      $content = $(this.hash);
      $active.addClass('active').parent().addClass('parent-active');
      $content.show();
      e.preventDefault();
    });
  });*/
  
  $('.btn-pwrap').on('click', function() {
    var $this = $('.pwrap');
    if ($this.data('open')) {
      $this.animate({height:'56px'}, 0 );
      $this.data('open', 0);
    }else{
      $this.animate({height:'100%'});
      $this.data('open', 1);
    }
  });
  $('.btn-pwrap').click(function(){
    var $this = $(this);
    $this.toggleClass('btn-pwrap');
    if($this.hasClass('btn-pwrap')){
      $this.text('more details');         
    } else {
      $this.text('less details');
    }
  });
  $('.btn-showAnswer').click (function (e){
	e.preventDefault();
	$(this).parent().find('.hidden-answer').slideToggle(250).toggleClass('active');
    $(this).parent().find('.btn-showAnswer').toggleClass('active');
	$(this).parent().find('.arrow').toggleClass('down');
	return false;
  });
  
  $('.flavor-btn a').click(function() {
    $(this).addClass('selected').siblings().removeClass('selected');
    var target = $(this).data('target');
    if (target === 'all') {
      $('.targetDiv').show();
    } else {
      $('.targetDiv').hide();
      $('#div' + target).show();
      $('#div-' + target).show();
    }
  });
  $(".otg-box-wrap li").hover(function() {
    $(this).children('.hovered-content').fadeIn(200);
    }, function () {
      $(this).children('.hovered-content').fadeOut(200);
    }
  );
  $(".lean1-bar .otg-box-wrap li .content").hover(function() {
    $(this).parent('.lean1-bar .otg-box-wrap li').addClass('open');
    $('.lean1-bar .otg-box-wrap ul').addClass('mobile-top');
    }, function () {
      $(this).parent('.lean1-bar .otg-box-wrap li').removeClass('open');
      $('.lean1-bar .otg-box-wrap ul').removeClass('mobile-top');
    }
  );
  setTimeout(function(){
    $(".bundle-wrap input[type='radio']").click(function () {
      $('.bundle-wrap input:not(:checked)').parent().removeClass("active-label");
      $('.bundle-wrap input:checked').parent().addClass("active-label");
      $(".subscription-container input[type='radio'], .rc_widget__option__selector input[type='radio']").prop('checked', false);
      $('.product-single__add-to-cart').hide();
      $('.subscription-option-bundle, .subscription-option-bundle .btn__wrap').show();
    });
    $(".subscription-container input").click(function () {
      $('.bundle-wrap label').removeClass("active-label");
      $(".bundle-wrap input[type='radio']").prop('checked', false);
      $('.product-single__add-to-cart').show();
      $('.subscription-option-bundle, .subscription-option-bundle .btn__wrap').hide();
      
      if ($("#lean1-15-serving-tub").length > 0 || $("#lean1-5-lb").length > 0 || $("#lean1-plant-based-15-serving-tub").length > 0 || $("#lean1-vegan").length > 0 || $("#lean1-keto-15-serving-tub").length > 0 ) {
        $(".serving-price-custom").hide();
        $('.serving-price.three').show();
      }
      
    });
  
    $(".rc-widget label").click(function () {
      $('.bundle-wrap label').removeClass("active-label");
      $('.bundle-container').removeClass('active-selected');
      $(".subscription-container input[type='radio'], .oz-wrap input[type='radio']").prop('checked', false);
      //$('.bundle-wrap').appendTo('.dummy_bundle');
      $('.product-single__add-to-cart').show();
      $('.subscription-option-bundle, .subscription-option-bundle .btn__wrap').hide();
    });
    $('.oz-wrap input[type="radio"]').click(function () {
      $('.rc-radio__input').prop('checked', false);
    });  
  

    
 
 
  
    $('.subscription-option-bundle input').on('change', function() {
     
      if($("input[value='bundle_time']").is(":checked")) {
        $(".subscription-option-bundle .btn__wrap").show();
        $('.product-single__add-to-cart').hide();
        
        if ($("#lean1-15-serving-tub").length > 0 || $("#lean1-5-lb").length > 0 || $("#lean1-plant-based-15-serving-tub").length > 0 || $("#lean1-vegan").length > 0 || $("#lean1-keto-15-serving-tub").length > 0 ) {
          $(".serving-price-custom").show();
          $('.serving-price.three').hide();
        }
        
      } else if($("input[value='one_time']").is(":checked")) {
        $(".subscription-option-bundle .btn__wrap").show();
        $('.product-single__add-to-cart').hide();
        
        if ($("#lean1-15-serving-tub").length > 0 || $("#lean1-5-lb").length > 0 || $("#lean1-plant-based-15-serving-tub").length > 0 || $("#lean1-vegan").length > 0 || $("#lean1-keto-15-serving-tub").length > 0 ) {
          $(".serving-price-custom").hide();
          $('.serving-price.three').show();
        }
        
      }
      
    });
    if ($("#lean1-neuro").length > 0 || $("#lean1-15-serving-tub").length > 0 || $("#lean1-5-lb").length > 0 || $("#lean1-plant-based-15-serving-tub").length > 0 || $("#lean1-vegan").length > 0 || $("#lean1-keto-15-serving-tub").length > 0 ) {
        $(".oz-wrap input").click(function() {
          
          var clicked = [];
          var clicked2 = [];
          $(".oz-wrap .active-label input[type=number]").each(function() {
            clicked.push(" "+this.value);
          });
          $(".oz-wrap .active-label .b_price").each(function() {
            clicked2.push(" "+this.value);
          });
          $('.o_span').html(clicked);
          $('.b_span, .serving-price-custom').html(clicked2);
          
          $(".subscription-option-bundle .btn__wrap").show();
          $('.product-single__add-to-cart').hide();
        }); 
      }
  }, 3000);
  
    
  $('.popup-modal').magnificPopup({
	type: 'inline',
	preloader: false,
	modal: true
  });
  $(document).on('click', '.popup-modal-dismiss', function (e) {
	e.preventDefault();
	$.magnificPopup.close();
  });
    
  $("#variant_option").change(function(){
    $(this).find("option:selected").each(function(){
      var optionValue = $(this).data("value");
      if(optionValue){
        $(".variant-img img").not("." + optionValue).hide();
        $("." + optionValue).show();
      } else{
        $(".variant-img img").hide();
      }
    });
  }).change();
    
  if (jQuery(window).width() <= 900){
    $("footer .title").click(function(){
      $(this).parent().find(".tab-mobile-content").slideToggle(300);
      $(this).parent().find('.fa').toggleClass('fa-angle-down');
    });
  };
  $(".btnRecipesHomeShow").on("click",function(){
	var obj = $(this);
	obj.parent().slideToggle(300);
	obj.parent().next().fadeToggle(300);
  });
	
  $(".btnRecipesHomeHide").on("click",function(){
	var obj = $(this);
	obj.parent().fadeToggle(300);
	obj.parent().prev().slideToggle(300);
  });  
  $("#btnFilterRecipes").click(function(){
	$("#filterRecipes").slideToggle(300);
  });
  $("#filterRecipes").mouseleave(function(){
	$(this).slideUp(300);
  });
    
  /*VIP Page*/  
  var windowH = $(window).height();
  var wrapperH = $('.vip-hero').height();
  if (windowH > wrapperH) {
    $('.vip-hero').css({
      'height': ($(window).height()) + 'px'
    });
  }
  $(window).resize(function () {
    var windowH = $(window).height();
    var wrapperH = $('.vip-hero').height();
    var differenceH = windowH - wrapperH;
    var newH = wrapperH + differenceH;
    var truecontentH = $('.vip-hero').height();
    if (windowH > truecontentH) {
      $('.vip-hero').css('height', (newH) + 'px');
    }
  });
  $('.viphero-inner a').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html,body').animate({
          scrollTop: target.offset().top
        }, 1000);
        return false;
      }
    }
  });
    
  var options = $('#Linklist-2 li a');
  var arr = options.map(function(_, o) {
        return {
            t: $(o).text(),
            v: o.href
        };
    }).get();
    arr.sort(function(o1, o2) {
        return o1.t > o2.t ? 1 : o1.t < o2.t ? -1 : 0;
    });
    options.each(function(i, o) {
        //console.log(i);
        o.href = arr[i].v;
        $(o).text(arr[i].t);
  });
    
  // Product Landing
  $('#nutri-vars').on('change', function() {
     $('.nutrifact-content').hide();
     $(".nutrifact-content[data-value="+$(this).find(':selected').attr('data-value')+"]").show();
  }).change();
    
});
  
/* Setting and Getting of Cookies */
function setCookie(c_name,value,exdays) {
  var exdate=new Date();
  exdate.setDate(exdate.getDate() + exdays);
  var c_value=escape(value) + ((exdays==null) ? "" : "; expires="+exdate.toUTCString());
  document.cookie=c_name + "=" + c_value;
}

function getCookie(c_name) {
  var i,x,y,ARRcookies=document.cookie.split(";");
  for (i=0;i<ARRcookies.length;i++) {
    x=ARRcookies[i].substr(0,ARRcookies[i].indexOf("="));
    y=ARRcookies[i].substr(ARRcookies[i].indexOf("=")+1);
    x=x.replace(/^\s+|\s+jQuery/g,"");
    if (x==c_name) {
      return unescape(y);
    }
  }
}